import React from 'react';

import successImg from '../../asset/img/common/check_circle_icon.svg';
import basicImg from '../../asset/img/common/information_icon.svg';
import errorImg from '../../asset/img/common/warning_triangle_icon.svg';
import { TextFieldStyled } from '../../asset/styled/component/TextFieldStyled';

const TextField = ({
  value,
  onChange,
  width = '100%',
  variant = 'outline',
  size = 'medium',
  labelSize = 'medium',
  placeholder,
  height,
  onKeyUp = () => {},
  setFocus,
  autocomplete,
  useRef,
  labelStyle,
  label,
  message,
  className,
  disabled,
  textarea = false,
  type = 'text',
  readOnly,
  inputStyle,
  messageStatus,
  name,
  disabledBackground = false,
  inputMode,
  pattern,
  onInputFocus,
  onInputBlur,
  ...rest
}) => {
  const commonProps = {
    value,
    placeholder,
    disabled,
    onChange,
    readOnly,
    name,
    style: inputStyle,
    inputMode,
    pattern,
  };

  const handleKeyUp = e => {
    if (e.key === 'Enter') onKeyUp();
  };

  const handleFocus = e => {
    if (autocomplete) setFocus(true);
    if (onInputFocus) onInputFocus(e);
  };

  const handleBlur = e => {
    if (autocomplete) setFocus(false);
    if (onInputBlur) onInputBlur(e);
  };

  const renderMessageIcon = () => {
    switch (messageStatus) {
      case 'error':
        return <img src={errorImg} alt="Error" />;
      case 'success':
        return <img src={successImg} alt="Success" />;
      case 'basic':
        return <img src={basicImg} alt="Info" />;
      default:
        return null;
    }
  };

  return (
    <TextFieldStyled
      className={className}
      width={width}
      height={height}
      variant={variant}
      size={size}
      disabled={disabled}
      messageStatus={messageStatus}
      disabledBackground={disabledBackground}
      {...rest}>
      {label && <label className="label">{label}</label>}
      <div className="inputWrapper">
        {textarea ? (
          <textarea
            ref={useRef}
            {...commonProps}
            onKeyUp={handleKeyUp}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
        ) : (
          <input
            ref={useRef}
            type={type}
            {...commonProps}
            onKeyUp={handleKeyUp}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
        )}
      </div>
      {message && (
        <div className="message">
          {renderMessageIcon()}
          <span className="captionMedium">{message}</span>
        </div>
      )}
    </TextFieldStyled>
  );
};

export default TextField;
